// extracted by mini-css-extract-plugin
module.exports = {"landing":"landing_landing__1TeYM"};